import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import IconButton from "@mui/joy/IconButton";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { DrawerWrapper } from "../../../shared/components/layout/DrawerWrapper";
import { PersonId } from "../../../models/person";
import { AllPatientsDropdown } from "../../patients/components/AllPatientsDropdown";

interface StudyAddParticipantDrawerProps {
  readonly onClose: () => void;
  readonly onParticipantAdded: (personId: PersonId) => void;
}

export default function StudyAddParticipantDrawer({
  onClose,
  onParticipantAdded,
}: StudyAddParticipantDrawerProps) {
  return (
    <DrawerWrapper>
      <>
        <Box sx={{ p: 2, display: "flex", alignItems: "center" }}>
          <Typography level="title-md" sx={{ flex: 1 }}>
            Add participant
          </Typography>
          <IconButton component="span" variant="plain" color="neutral" size="sm">
            <CloseRoundedIcon onClick={onClose} />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={{ background: "white", flexGrow: 1, p: 2 }}>
          <Stack sx={{ mb: 2 }} direction="column" gap={2}>
            <Typography level="body-md">
              Select a participant to add to the study. Its status will be "screening".
            </Typography>
            <AllPatientsDropdown onSelect={(p) => !!p && onParticipantAdded(p.person_id)} />
          </Stack>
        </Box>
      </>
    </DrawerWrapper>
  );
}
